import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

const BodyLock = _ref => {
  let {
    active,
    scrollableRef
  } = _ref;
  const fallbackRef = useRef();
  const targetRef = scrollableRef || fallbackRef;
  useEffect(() => {
    if (targetRef && targetRef.current) {
      active ? disableBodyScroll(targetRef.current, {
        allowTouchMove: el => targetRef === null || targetRef === void 0 ? void 0 : targetRef.current.contains(el)
      }) : enableBodyScroll(targetRef.current);
    }

    return () => clearAllBodyScrollLocks();
  }, [active, targetRef]);
  return /*#__PURE__*/React.createElement("div", {
    ref: fallbackRef
  });
};

BodyLock.defaultProps = {
  active: false
};
BodyLock.propTypes = {
  /** Boolean flag to indicate if the body lock is active */
  active: PropTypes.bool,

  /** A ref to an element which should remain scrollable even when the lock is active. */
  scrollableRef: PropTypes.object
};
export default BodyLock;